import { render, staticRenderFns } from "./pg_business_dxsolution.vue?vue&type=template&id=463c021f"
import script from "./pg_business_dxsolution.vue?vue&type=script&lang=js"
export * from "./pg_business_dxsolution.vue?vue&type=script&lang=js"
import style0 from "./pg_business_dxsolution.vue?vue&type=style&index=0&id=463c021f&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports